<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Receiving PO Inventory - Oustanding Processed 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="pilih">Select</b-button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="(filterShow=='Hide')">
        <b-col lg="6">
              <b-row>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Purc.Order No.</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.nomor" placeholder="Order Number"></b-form-input>
                    </b-input-group>
                  </b-col>
                <b-col  lg="6">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Receiving No. &nbsp;</span></b-input-group-prepend>
                      <b-form-input v-model="tblData.RecivNo" placeholder="Receiving Number"></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>          
            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
              </b-input-group>

              <b-input-group >
                <b-input-group-prepend><label>Receiving Date</label></b-input-group-prepend>
                <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
              </b-input-group>
        </b-col>
        <b-col lg="6">
            <b-row>
              <b-col lg="8">
                  <b-input-group >
                    <b-input-group-prepend><label>Vendor/Supplier</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.vendor" placeholder="Vendor/Supplier"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="4">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Delivery No.&nbsp;</span></b-input-group-prepend>
                      <b-form-input v-model="tblData.DoNumber" placeholder="Delivery Number"></b-form-input>
                    </b-input-group>
                </b-col>
            </b-row>            
            <b-input-group >
                <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                <b-form-input v-model="tblData.uraian" ></b-form-input>
            </b-input-group>
              <b-row>
                <b-col lg="8">
                    <b-input-group >
                      <b-input-group-prepend><label>Item Name/Desc.</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.item" placeholder="Material/Service Name"  @change="itemChange"></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="lkuItemShow=true" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                    </b-input-group>
                  </b-col>
                <b-col  lg="4">
                    <b-input-group >
                      <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" size="sm"> <i class="fa fa-refresh"></i> Apply Filter</b-button>
                      <b-button class="btn btn-secondary mr-1" @click="clearFilter()" size="sm"> <i class="fa fa-eraser"></i>Clear Filter</b-button>
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch class="ml-1 mt-1">
                          <b> {{ filterShow }}</b> Filter
                        </b-form-checkbox>
                    </b-input-group>
                </b-col>
              </b-row>                      
        </b-col>
      </b-row> 
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="tblItems"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        @row-clicked="rowClicked"
          @filtered="onFiltered"                
      >
        <template v-slot:cell(recivDate)="data">
          {{ data.item.recivDate | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(rcpLineQty)="data">
          {{data.item.rcpLineQty}} &nbsp; {{data.item.unitsize}}
        </template>
        <template v-slot:cell(qtyProcGCIF)="data">
          {{data.item.qtyProcGCIF}} &nbsp; {{data.item.unitsize}}
        </template>
      </b-table>
        <b-row class="mt-2">
          <b-col cols="4">
            <div>
              Showing {{(tblData.page - 1) * tblData.limit + 1}}
              to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
              of {{tblData.total}} entries,   <span class="ml-3 mr-1">limit per page :</span> 
              <input type="number" style="width:80px;" v-model="tblData.limit"/>
            </div>
          </b-col>                      
          <b-col cols="3">            
            <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
              <b> {{ filterShow }}</b> Filter
            </b-form-checkbox>

          </b-col>
          <b-col cols="5">            
            <b-pagination 
              align="right"
              :total-rows="tblData.total"
              :per-page="tblData.limit"
              v-model="tblData.page"
            ></b-pagination>
          </b-col>
        </b-row>      
    </b-card>
    <b-card v-if="showForm">
      <div slot="header">Inventory Receipt Form 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="save()" v-if="saveEnabled==true">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
        </div>
      </div>
        <b-row>
            <b-col lg="6">
                <b-row>
                    <b-col lg="6">
                        <b-input-group>
                            <b-input-group-prepend><label >Receiving Date</label></b-input-group-prepend>
                            <b-form-input v-model="frmdata.recivDate" readonly></b-form-input>
                        </b-input-group>
                    </b-col>
                    <b-col lg="6">
                        <b-input-group>
                            <b-input-group-prepend><label>Receiving Number</label></b-input-group-prepend>
                            <b-form-input v-model="frmdata.purcRcpHdNo" readonly></b-form-input>
                        </b-input-group>
                    </b-col>
                </b-row>
                <b-input-group>
                    <b-input-group-prepend><label>Supplier</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata.vendorinfo" style="width:40% !important;" readonly></b-form-input>
                    <b-input-group-prepend><span class="pt-2">Delivery No.</span></b-input-group-prepend>
                    <b-form-input v-model="frmdata.vndShipNo" readonly></b-form-input>
                </b-input-group>
                <b-input-group>
                    <b-input-group-prepend><label >Purchase Order No.</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata.purcOrderNo" style="width:40% !important;" readonly></b-form-input>
                    <b-form-checkbox  class="ml-2 mt-2" v-model="frmdata.barangbarter" disabled value=1 unchecked-value=0 style="font-weight:bolder;">P.O Barter</b-form-checkbox>
                    <b-input-group-prepend><span class="p-2 ml-1">Qty. PO</span></b-input-group-prepend>
                    <b-input-group-prepend><span class="input-group-text">{{frmdata.QtyPO}} {{frmdata.unitsize}}</span></b-input-group-prepend>
                </b-input-group>
                <b-input-group>
                    <b-input-group-prepend><label>Qty. Receiving</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata.rcpLineQty" readonly="" v-b-tooltip.hover :title="`Ostanding quantity Processed as inventory: ${frmdata.rcpLineQtyOst} ${frmdata.unitsize}`"></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">{{frmdata.unitsize}}</span></b-input-group-prepend>
                    <b-input-group-prepend><span class="ml-3 pt-2">Value</span></b-input-group-prepend>
                    <b-input-group-prepend class="ml-2"><span class="input-group-text">{{frmdata.matauang}}</span></b-input-group-prepend>
                    <my-number class="form-control text-right" v-model="frmdata.nilainett" :precision="2" readonly></my-number>
                </b-input-group>
            </b-col>
            <b-col lg="6"> 
                <v-dim :model="frmdata" ></v-dim>
            </b-col>
        </b-row>

      <hr>
      <b-row h-align="center">
          <b-col lg="6">
            <b-form-row>
              <b-col lg="7">                            
                  <b-input-group>
                      <b-input-group-prepend><label>Item Code</label></b-input-group-prepend>
                      <b-form-input readonly v-model="frmdata.partnumber"></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col lg="5">
                  <b-input-group>
                    <b-form-checkbox  class="ml-2 mt-2" v-model="frmdata.barangbarter" value=1 unchecked-value=0 disabled>Barter Item</b-form-checkbox>
                  </b-input-group>
              </b-col>
            </b-form-row >                      
              <b-input-group>
                  <b-input-group-prepend><label>Item Name</label></b-input-group-prepend>
                  <b-form-input readonly v-model="frmdata.itemname"></b-form-input>
              </b-input-group>
              <b-input-group>
                  <b-input-group-prepend><label>Model/Type/Series</label></b-input-group-prepend>
                  <b-form-input readonly v-model="frmdata.typeseries"></b-form-input>
              </b-input-group>
              <b-input-group>
                  <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.description"></b-form-input>
              </b-input-group>
                <b-input-group>
                    <b-input-group-prepend><label>Unit Price P.O.</label></b-input-group-prepend>
                    <b-input-group-prepend>
                    <span class="input-group-text">{{frmdata.matauang}}</span>
                    </b-input-group-prepend>
                    <my-number class="form-control text-right" v-model="frmdata.nettpriceFCY" :precision="2" readonly></my-number>
                    <b-input-group-prepend class="ml-2">
                    <span class="input-group-text">{{uanguser}}</span>
                    </b-input-group-prepend>
                    <my-number class="form-control text-right" v-model="frmdata.nettprice" :precision="2" readonly></my-number>
                </b-input-group>
          </b-col>
          <b-col lg="6">
              <b-row>
                <b-col lg="7"> 
                  <b-input-group>
                      <b-input-group-prepend><label>Qty. Rcv Processed</label></b-input-group-prepend>
                      <b-form-input v-model="frmdata.qtyPurcRcp" type="number" :state="!$v.frmdata.qtyPurcRcp.$error" @change="calcQtyInvent()" :min="1" :max="frmdata.rcpLineQtyOst" v-b-tooltip.hover :title="`Ostanding quantity Processed as inventory: ${frmdata.rcpLineQtyOst} ${frmdata.unitsize}`"></b-form-input>
                      <b-form-input readonly v-model="frmdata.unitsize" class="ml-1"></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row >
              <b-row>
                <b-col lg="7"> 
                  <b-input-group>
                      <b-input-group-prepend><label>Qty Inventory Split</label></b-input-group-prepend>
                      <b-form-input v-model="frmdata.quantity" type="number" :state="!$v.frmdata.quantity.$error" :min="1" v-if="(frmdata.ishasserialno!=1)"></b-form-input>
                      <b-form-input v-model="frmdata.quantity" type="number" :state="!$v.frmdata.quantity.$error" :min="1" v-else readonly v-b-tooltip.hover title="Item has SERIAL NUMBER, must be receipt one by one"></b-form-input>
                      <b-form-input v-model="frmdata.invunitom" class="ml-1" :state="!$v.frmdata.invunitom.$error" :disabled="(frmdata.ishasserialno==1)"></b-form-input>
                  </b-input-group>
                </b-col>                  
                <b-col lg="5"> 
                    <span class="mt-2 text-primary font-weight-bold">Pemecahan terkecil</span>
                </b-col>                  
              </b-row >     
              <b-input-group>
                  <b-input-group-prepend><label>Inventory Unit Price</label></b-input-group-prepend>
                  <b-input-group-prepend>
                  <span class="input-group-text">{{uanguser}}</span>
                  </b-input-group-prepend>
                  <my-number class="form-control text-right" v-model="frmdata.invUnitCost" :state="!$v.frmdata.invUnitCost.$error" :precision="2" readonly></my-number>
                    <b-form-checkbox  class="ml-2 mt-2" v-model="frmdata.qtyUndefined" value=1 unchecked-value=0>Inventory Value Balance (Quantity UnDefined)</b-form-checkbox>
              </b-input-group>
                <b-input-group>
                    <b-input-group-prepend><label>Inventory Group</label></b-input-group-prepend>
                    <b-form-select v-model="frmdata.inven_catid" :plain="true" :options="headCategories" :state="!$v.frmdata.inven_catid.$error"></b-form-select>
                </b-input-group>

              <b-row>
                  <b-col lg="7">                            
                      <b-input-group>
                          <b-input-group-prepend><label>Store/Warehouse </label></b-input-group-prepend>
                          <b-form-select v-model="frmdata.idStore" :plain="true" :options="warehouse" :state="!$v.frmdata.idStore.$error"></b-form-select>
                      </b-input-group>
                  </b-col>
                  <b-col lg="5">                            
                      <b-input-group>
                          <b-input-group-prepend><label style="width:113px !important; text-align:right;">Rack/Shelf No.</label></b-input-group-prepend>
                          <b-form-input v-model="frmdata.shelfNo" :state="!$v.frmdata.shelfNo.$error"></b-form-input>
                      </b-input-group>
                  </b-col>
              </b-row >     
              <b-row>
                  <b-col lg="7" v-if="ishasserialno">                            
                      <b-input-group >
                          <b-input-group-prepend><label>Serial Number</label></b-input-group-prepend>
                          <b-form-input v-model="frmdata.serialNum" :state="!$v.frmdata.serialNum.$error"></b-form-input>
                      </b-input-group>
                  </b-col>
              </b-row >     
              <b-row>
                  <b-col lg="7" v-if="isexpireable">                            
                      <b-input-group >
                          <b-input-group-prepend><label>Expired Date</label></b-input-group-prepend>
                          <b-form-input v-model="frmdata.expirDate" type="date" :state="!$v.frmdata.expirDate.$error"></b-form-input>
                      </b-input-group>
                  </b-col>
              </b-row >     
          </b-col>
      </b-row>
      <hr>
      <b-form-checkbox  class="mt-2" v-model="frmdata.gcif" value=1 unchecked-value=0>Use GCIF(Goods Confirmity Inspection Form)</b-form-checkbox>
      <b-button block variant="info" :disabled="(frmdata.gcif==0)" @click.stop="showGCIF=!showGCIF">GOODS CONFORMITY INSPECTION FORM</b-button>
        <b-card no-body v-if="showGCIF">
            <h6 class="ml-2 mt-3"> 1. PACKAGING & HANDLING CHECK</h6>
            <b-card-group>
                <b-card>
                  <h6>A.TYPE</h6>
                  <b-form-radio-group stacked v-model="frmGCIFdata.typePack" name="packingType">
                    <b-form-radio value="Reusable Container">Reusable Container</b-form-radio>
                    <b-form-radio value="Wooden Box">Wooden Box</b-form-radio>
                    <b-form-radio value="Cartoon">Cartoon</b-form-radio>
                    <b-form-radio value="Unpacked">Unpacked</b-form-radio>
                  </b-form-radio-group>

                </b-card>
                <b-card>
                  <h6>B.CONDITION</h6>
                  <b-form-radio-group stacked v-model="frmGCIFdata.satisCondPack" name="packingCondition">
                    <b-form-radio :value="1">Satisfactory</b-form-radio>
                    <b-form-radio :value="0">UnSatisfactory</b-form-radio>
                  </b-form-radio-group>
                  <b-form-group  label="If Unsatisfactory explain :">
                    <b-form-textarea v-model="frmGCIFdata.unsatisConPackReason" rows="3" max-rows="6"></b-form-textarea>                    
                  </b-form-group>       
                </b-card>
            </b-card-group>
            <h6 class="ml-2 mt-3">2. PRESERVATION CHECK</h6>
            <b-card>
              <b-row>
                <b-col>
                  <b-form-radio-group stacked v-model="frmGCIFdata.satisPreserve" name="preservationCheck">
                    <b-form-radio :value="1">Satisfactory</b-form-radio>
                    <b-form-radio :value="0">UnSatisfactory</b-form-radio>
                  </b-form-radio-group>
                </b-col>
                <b-col>
                  <b-form-group  label="If Unsatisfactory explain :">
                    <b-form-textarea v-model="frmGCIFdata.unsatisPreserveReason" rows="2" max-rows="4" placeholder="Explaination Unsatisfactory Preservation Check"></b-form-textarea>                    
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
            <h6 class="ml-2">3. DOCUMENT CHECK</h6>
            <b-card-group>
                <b-card>
                  <h6>A. GENERAL DOCUMENT</h6>
                    <b-form-checkbox v-model="frmGCIFdata.inventoryGenDocument"  key="inventoryGenDocument" >Item/Inventory List</b-form-checkbox> <br>
                    <b-form-checkbox v-model="frmGCIFdata.tagGenDoc"  key="tagGenDoc" >Tag & Log Book</b-form-checkbox> <br>
                    <b-form-checkbox v-model="frmGCIFdata.shipGenDoc"  key="shipGenDoc" >Shipping Document</b-form-checkbox> <br>
                </b-card>
                <b-card>
                  <h6>B. TECHNICAL DOCUMENT</h6>
                  <b-form-radio-group stacked v-model="frmGCIFdata.satisTechDoc" name="technicaldoc">
                    <b-form-radio :value="1">Satisfactory</b-form-radio>
                    <b-form-radio :value="0">UnSatisfactory</b-form-radio>
                  </b-form-radio-group>
                  <b-form-group  label="If Unsatisfactory explain :">
                    <b-form-textarea v-model="frmGCIFdata.unsatisTechDocReason" rows="3" max-rows="6"></b-form-textarea>                    
                  </b-form-group>       
                </b-card>
            </b-card-group>
            <h6 class="ml-2 mt-3">4. MATERIAL CHECK</h6>
            <b-card-group>
                <b-card>
                  <h6>A. CONDITION</h6>
                  <b-form-radio-group stacked v-model="frmGCIFdata.satisCondMaterial" name="materialCondition">
                    <b-form-radio :value="1">Satisfactory</b-form-radio>
                    <b-form-radio :value="0">UnSatisfactory</b-form-radio>
                  </b-form-radio-group>
                  <b-form-group  label="If Unsatisfactory explain :">
                    <b-form-textarea v-model="frmGCIFdata.unSatisCondMaterialReason" rows="3" max-rows="6"></b-form-textarea>                    
                  </b-form-group>       
                </b-card>
                <b-card>
                  <h6>B. QUANTITY</h6>
                  <b-form-radio-group stacked v-model="frmGCIFdata.conformQtyMaterial" name="materialQty">
                    <b-form-radio :value="1">Confirm</b-form-radio>
                    <b-form-radio :value="0">Not Confirm</b-form-radio>
                  </b-form-radio-group>
                  <b-form-group  label="If Unsatisfactory explain :">
                    <b-form-textarea v-model="frmGCIFdata.unconformQtyMaterialReason" rows="3" max-rows="6"></b-form-textarea>                    
                  </b-form-group>       
                </b-card>
            </b-card-group>
            <h6 class="ml-2 mt-3">5. REASON FOR REJECTION (IF ANY AND DETAIL INCLUDING PHOTO)</h6>
            <b-card-group>
                <b-card>
                    <b-form-textarea v-model="frmGCIFdata.reasonReject" rows="3" max-rows="6" placeholder="Reason for Rejection"></b-form-textarea>                    
                  <div slot="footer" class="text-right">
                    <b-button variant="btn btn-primary mr-1" @click="toggleShowImg()"> <i class="fa fa-file-image-o"></i> Upload Photo</b-button>
                    <b-button variant="btn btn-primary mr-1" @click="deleImage()"><i class="fa fa-trash"></i> Delete Photo
                    </b-button>
                    </div>
                </b-card>
                <b-card>
                  <my-upload field="gambar" :noCircle="true"
                      @crop-success="cropSuccess"
                      @crop-upload-success="cropUploadSuccess"
                      @crop-upload-fail="cropUploadFail"
                      v-model="showImgTool"
                      :width="300"
                      :height="300"
                      :url="imgUploadUrl"
                      langType="en"
                      :params="imgParams"
                      :headers="imgHeaders"
                      img-format="png"></my-upload>
                  <img :src="imgDataUrl">
                </b-card>
            </b-card-group>
        </b-card>
    </b-card>

        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Master Item Inventory" :centered="true">
            <lku-item @click="onSelectLkuItem"  jasa="0" isactive="1" :formdata="itemList" ></lku-item>
        </b-modal>        
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

  </div>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from "moment";
import 'babel-polyfill'; // es6 shim
import myUpload from 'vue-image-crop-upload';
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
import myNumber from "../../components/my-number";
import lkuItem from "../lookup/lkuItemLazzy";
import vDim from "../lookup/dim";
import procreceiv from "../../apis/procreceiv";
import inv from "../../apis/logistic_inv_in";

toastr.init();

export default {
  components: { Loading,myNumber, myUpload, lkuItem, vDim},
  mixins: [validationMixin],
  validations: {
    frmdata: {
        quantity: { required },
        invUnitCost: { required },
        invunitom: { required },
        inven_catid: { required },
        qtyPurcRcp: { required },
        invUnitCost: { required },
        idStore : { required },
        shelfNo : { required },
        serialNum: { required:requiredIf('ishasserialno') },
        expirDate: { required:requiredIf('isexpireable') }
    },
  },
  data() {
    return {
      lkuItemShow:false,
      itemList:{},

      showDelConfirm: false,
      isLoading:false,
      showList:true,
      showForm:false,
      filterShow:'Hide',
      lkuUserShow:false,
      lkuUserCaller:'filter.username',
      filter:{itemname:''},
      showGCIF:false,
      saveEnabled:true,
      frmdata:{quantity: 0, invunitom: '',qtyPurcRcp:1, gcif:0, idStore:'',shelfNo:'',
      ishasserialno:0, serialNum:'',isexpireable:0, expirDate:'', inven_catid:'', barangbarter:0},
      frmGCIFdata:{unsatisConPackReason:'',unsatisPreserveReason:'',unsatisTechDocReason:'', unSatisCondMaterialReason:'', unconformQtyMaterialReason:'', reasonReject:''},
      uanguser: this.$store.state.user.matauang,
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        // tgl2:moment().format('YYYY-MM-DD')this.$store.state.user.akhirbln,
        tgl2:moment().format('YYYY-MM-DD'),
        sortBy: 'RecivDate',
        sortDesc: false,
      },
      tblItems:[],
      showImgTool:false,
      imgParams:{name:'gambar'},
      imgHeaders:{},
      imgDataUrl: '',
      imgUploadUrl: '',
      warehouse:[],headCategories:[]
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    isexpireable(){
        return (this.frmdata.isexpireable == 1);
    },
    ishasserialno(){
        return (this.frmdata.ishasserialno == 1);
    },
    tblFields(){
      const fields=[
          {
            key: "recivDate",
            thStyle: "width:90px",
            label: "Receiving Date",
            sortable: true
          },
          {
            key: "RecivNo",
            thStyle: "width:100px",
            label: "Receiving No",
            sortable: true
          },
          {
            key: "purcOrderNo",
            label: "Purchase Order#",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "vendorinfo",
            label: "Supplier",
            sortable: true
          },
          {
            key: "namaacc",
            label: "Inventory Group",
            sortable: true
          },
          {
            key: "partnumber",
            label: "Item Code",
            sortable: true
          },
          {
            key: "itemname",
            label: "Item Name",
            sortable: true
          },
          {
            key: "typeseries",
            label: "Type/ series",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "rcpLineQty",
            label: "Qty.Delivered",
            thStyle: "width:100px",
          },
          {
            key: "qtyProcGCIF",
            label: "Qty.Processed as Inventory",
            thStyle: "width:100px",
          },
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
    qtyPurcRcp(){
        return this.frmdata.qtyPurcRcp;
    },
    qtyInventory(){
        return this.frmdata.quantity;
    },
    useGCIF(){
      return this.frmdata.gcif;
    }
  },
  watch : {
    useGCIF: function(newVal) {
        if (newVal == 0) {
          this.showGCIF= false;
        } else if (newVal == 1) {
          this.showGCIF= true;
        }
    },
    qtyPurcRcp:function(newVal) {
              this.frmdata.invUnitCost = (this.frmdata.nettprice * newVal)/this.frmdata.quantity;
    },
    qtyInventory:function(newVal) {
              this.frmdata.invUnitCost = (this.frmdata.nettprice * this.frmdata.qtyPurcRcp)/newVal;
    },
  },
  created: async function(){
        const [a,b] = await Promise.all([procreceiv.inventorygroup(),procreceiv.store()]) ;
        this.headCategories = a; 
      this.warehouse = b; 
      if (b[0]) {
        this.frmdata.idStore= b[0].value;
      }   
    console.log('route.params: ', this.$route.params);
    if (this.$route.params.purcOrderNo || this.$route.params.RecivNo) {
      this.tblData.nomor= this.$route.params.purcOrderNo;
      this.tblData.RecivNo=this.$route.params.RecivNo;
    }
      this.refresh();
  },
  methods: {
    onSelectLkuItem: function (lkuData) {
        this.itemList=lkuData;
        this.lkuItemShow=false;

        this.tblData.itemno = lkuData.selected.itemno;
        this.tblData.item = lkuData.selected.itemname;
    },
    itemChange: function () {
        this.tblData.itemno = '';
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },      
    async refresh() {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      try {
        this.isLoading=true;
        const list = await procreceiv.inventory(this.tblData);          
        this.isLoading=false;
        this.tblItems= list;
        this.tblData.total=list.length;
      } catch (error) {
        this.isLoading=false;
        if (error.message) {
            toastr.error(error.message,'ERROR MESSAGE',10000);
        } else {
            toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
        }
      } 
    },
    pilih: async function() {
        if (this.model.RecivKey) {
          // for (var key in this.frmdata) {
          //     this.frmdata[key] = '';
          // }
          this.frmdata.quantity= 0;
           this.frmdata.invunitom= '';
          this.frmdata.qtyPurcRcp=1;
           this.frmdata.gcif=0;
           this.frmdata.idStore='';
          this.frmdata.shelfNo='';
          this.frmdata.serialNum='';
          this.frmdata.expirDate='';
          this.frmdata.inven_catid='';
           this.frmdata.barangbarter=0
           this.frmdata.receiptSrc='PO RECEIPT'
          for (var key in this.model) {
              this.frmdata[key] = this.model[key];
          }
          // this.frmdata.description=this.frmdata.description || `${this.model.purcOrderNo} ${this.model.vendorinfo} ${this.model.remark}`;
          this.frmdata.description= `${this.model.purcOrderNo} ${this.frmdata.description || this.model.remark}, supplier:${this.model.vendorinfo}`;
          // if (this.model.postKodeacc) {
          //     const ada = this.headCategories.find(c => c.kodeacc==this.model.postKodeacc);
          //     if (ada) {
          //         this.frmdata.inven_catid=this.model.postKodeacc
          //     }
          // }

          this.dimension.forEach((dim) => {
              if (this.model[dim.value]) {
                  this.frmdata[`${dim.value}Info`] = this.model[dim.value] + ' | '+ this.model[`${dim.value}Txt`];
          console.log( this.frmdata[`${dim.value}Info`]);
              }
          });  

          this.frmdata.recivDate=moment(this.model.recivDate).format('YYYY-MM-DD');
          // this.frmdata.satisCondPack=1;
          // this.frmdata.satisPreserve=1;
          // this.frmdata.satisTechDoc=1;
          // this.frmdata.satisCondMaterial=1;
          // this.frmdata.conformQtyMaterial=1;
          // this.frmdata.typePack='Cartoon';
          this.frmdata.qtyPurcRcp = 1;
          this.frmdata.quantity = 1;
          this.frmdata.unitsize=this.frmdata.unitsize || (this.frmdata.invunitom || 'EACH');
          this.frmdata.invunitom= this.frmdata.invunitom || this.frmdata.unitsize;
          if (this.frmdata.ishasserialno==1) {
              this.frmdata.quantity=1;
              this.frmdata.qtykonversi=1;
              this.frmdata.qtyPurcRcp=1
              this.frmdata.invunitom=this.frmdata.unitsize;
          }

          if (this.frmdata.unitsize == this.frmdata.invunitom) {
            this.frmdata.qtyPurcRcp = this.frmdata.rcpLineQtyOst;
            this.frmdata.quantity = this.frmdata.rcpLineQtyOst;
          } if ( (this.frmdata.invunitom.toUpperCase().includes(this.frmdata.unitsize.toUpperCase())) || 
                (this.frmdata.unitsize.toUpperCase().includes(this.frmdata.invunitom.toUpperCase())) ) {
            this.frmdata.qtyPurcRcp = this.frmdata.rcpLineQtyOst;
            this.frmdata.quantity = this.frmdata.rcpLineQtyOst;
          }
          this.frmdata.invUnitCost=this.model.unitprice;

          const data = await procreceiv.token();
          this.imgHeaders= data.headers;
        // this.imgUploadUrl= `${data.baseURL}/item/uploadImage`;
        // this.imgParams= {itemReciKey:this.model.itemReciKey};

          this.showForm=true;
          this.showList=false;
          this.saveEnabled=true;          
          procreceiv.receiptinventory(this.model).then(line => {
                this.frmdata.qtyPurcRcp = line.rcpLineQtyOst;
                this.model.rcpLineQtyOst= line.rcpLineQtyOst;
                if (this.frmdata.unitsize == this.frmdata.invunitom) {
                  this.frmdata.quantity = this.frmdata.rcpLineQtyOst;
                }
                this.saveEnabled=(this.frmdata.rcpLineQtyOst>0.5);
              })
              .catch(err => {
                  console.log('get receiptinventory -> ', err);
              });

        } else {
            toastr.warn('Please select a row that want to be Select!');
        }

    },
    calcQtyInvent(){
       let satuanSama=false;
        if (this.frmdata.unitsize == this.frmdata.invunitom) {
            satuanSama=true;
          } if ( (this.frmdata.invunitom.toUpperCase().includes(this.frmdata.unitsize.toUpperCase())) || 
                (this.frmdata.unitsize.toUpperCase().includes(this.frmdata.invunitom.toUpperCase())) ) {
            satuanSama=true;
        }
      if(satuanSama==false){
        this.frmdata.quantity = this.frmdata.qtyPurcRcp *(this.model.qtykonversi || 1)
      }
    },
    save: async function (callback) {
      this.saveEnabled=false;
       let satuanSama=false;
        if (this.frmdata.unitsize == this.frmdata.invunitom) {
            satuanSama=true;
          } if ( (this.frmdata.invunitom.toUpperCase().includes(this.frmdata.unitsize.toUpperCase())) || 
                (this.frmdata.unitsize.toUpperCase().includes(this.frmdata.invunitom.toUpperCase())) ) {
            satuanSama=true;
        }

        if (this.invalidFormdata) {
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
                this.saveEnabled=true;
        } else if ((satuanSama==false) && (this.frmdata.quantity == this.frmdata.qtyPurcRcp) ) {
            toastr.error('Quantity convertion not valid', "ERROR MESSAGE");
              this.saveEnabled=true;
        } else if ((satuanSama==true) && (this.frmdata.quantity < this.frmdata.qtyPurcRcp) ) {
            toastr.error('Quantity convertion not valid', "ERROR MESSAGE");
              this.saveEnabled=true;
        }else {
            try {
              // Note apakah perlu dibuatkan validation saat input gcif
              // this.frmdata.gcifData = this.frmGCIFdata;
              // this.frmdata.invValue = this.frmdata.nettprice * this.frmdata.qtyPurcRcp;
              // this.frmdata.invValueFCY = this.frmdata.nettpriceFCY * this.frmdata.qtyPurcRcp;
              // this.frmdata.invUnitCost = (this.frmdata.nettprice * this.frmdata.qtyPurcRcp)/this.frmdata.quantity;
              // this.frmdata.invUnitCostFCY = this.frmdata.nettpriceFCY;
              // const result = await inv.invReceipt_save(this.frmdata);

              const data = {};
              for (var key in this.frmdata) {
                  data[key] = this.frmdata[key];
              }
              data.gcifData = this.frmGCIFdata;
              data.invValue = this.frmdata.nettprice * this.frmdata.qtyPurcRcp;
              data.invValueFCY = this.frmdata.nettpriceFCY * this.frmdata.qtyPurcRcp;
              data.invUnitCost = (this.frmdata.nettprice * this.frmdata.qtyPurcRcp)/this.frmdata.quantity;
              data.invUnitCostFCY = this.frmdata.nettpriceFCY;

              await inv.save(data);
              this.showGCIF = false;
              this.showForm = false;
              this.model={};
              toastr.success("Complete successfully", "Save Inventory Receipt");
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 300);       
              
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
                this.saveEnabled=true;
            }
        }
    },   

    rowClicked(record, index) {
      if ((this.model || {}).RecivKey==record.RecivKey) {
        this.pilih();
      } else {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();

      }
    },
    clearFilter(){
      this.tblData.nomor ='';
      this.tblData.tgl1 ='';
      this.tblData.tgl2 ='';
      this.tblData.RecivNo='';
      this.tblData.uraian='';
      this.tblData.item='';
      this.tblData.itemno = '';
      this.tblData.DoNumber='';
    },
    closeFrm(){
      this.showForm = false;
      this.showGCIF = false;
      this.showList=true;
      this.saveEnabled=true;
    },    
    close(){
      // if (this.$store.state.prevRoute.name) {
      //   router.push({name:this.$store.state.prevRoute.name});
      // } else {
        router.push({name:'logistic.inv_in'});
      // }
    },   
        toggleShowImg() {
              this.showImgTool = !this.showImgTool;
          },
          /**
           * crop success
           *
           * [param] imgDataUrl
           * [param] field
           */
          cropSuccess(imgDataUrl, field){
              console.log('-------- crop success --------', field);
              this.imgDataUrl=imgDataUrl;
              // console.log(imgDataUrl);
              // console.log('content ',this[field]);
          },
          /**
           * upload success
           *
           * [param] jsonData  server api return data, already json encode
           * [param] field
           */
          cropUploadSuccess(jsonData, field){
              console.log('-------- upload success --------');
              console.log(jsonData);
              console.log('field: ' + field);
          },
          /**
           * upload fail
           *
           * [param] status    server api return error status, like 500
           * [param] field
           */
          cropUploadFail(status, field){
              console.log('-------- upload fail --------');
              console.log(status);
              console.log('field: ' + field);
          }

  }
};
</script>
